import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Components/CardOwl.css";
import "../Components/Card.css";
import { Link } from "react-router-dom";
import FlipCard from "../Components/FlipCard";

import Card1 from "../Images/CIRCODU-BANNERS.jpg";
import Card2 from "../Images/CIRCODU-BANNERS-3.jpg";
import Card3 from "../Images/CIRCODU-BANNERS-2.jpg";
import Card4 from "../Images/CIRCODU-BANNERS-5.jpg";
import Card5 from "../Images/CIRCODU-BANNERS-4.jpg";

const scrollToTop = () => window.scrollTo(0, 0);

const THEMATIC_CARDS = [
  {
    id: "1",
    img: Card1,
    alt: "Energy — CIRCODU Thematic Area",
    title: "Energy",
    slug: "/our-thematic-areas/energy",
    excerpt:
      "Access to sustainable energy is not a luxury; it is a cornerstone of economic growth, environmental health, and poverty reduction. CIRCODU recognizes this reality and has made the promotion of sustainable energy resource use a central pillar of its mission, working hand-in-hand with stakeholders across Uganda to make clean energy a lived reality for households, institutions, and enterprises nationwide. ...",
  },
  {
    id: "2",
    img: Card2,
    alt: "Public Health — CIRCODU Thematic Area",
    title: "Public Health",
    slug: "/our-thematic-areas/public-health",
    excerpt:
      "Health is not a privilege — it is a foundation. Without it, communities cannot learn, work, grow, or thrive. CIRCODU recognizes that public health is inseparable from sustainable development, and that addressing poor health outcomes requires tackling the deeper forces that drive them: poverty, inequality, lack of access to services, and environmental degradation. ...",
  },
  {
    id: "3",
    img: Card3,
    alt: "Water and Sanitation — CIRCODU Thematic Area",
    title: "Water and Sanitation",
    slug: "/our-thematic-areas/water-and-sanitation",
    excerpt:
      "Access to clean, safe water is not a privilege; it is a fundamental human right. Yet across Uganda, countless communities still face the daily reality of insufficient access to clean water and adequate sanitation, with devastating consequences for health, education, and economic opportunity. CIRCODU is committed to changing that. Anchored in the principles ...",
  },
  {
    id: "4",
    img: Card4,
    alt: "Agricultural Management — CIRCODU Thematic Area",
    title: "Agricultural Management",
    slug: "/our-thematic-areas/agricultural-management",
    excerpt:
      "Agriculture is the heartbeat of Uganda's economy. It feeds families, drives livelihoods, and holds the key to ending poverty for millions. Yet the way we farm today will determine whether the land can sustain us tomorrow. CIRCODU is committed to ensuring that it can. By promoting sustainable agricultural practices and responsible land ...",
  },
  {
    id: "5",
    img: Card5,
    alt: "Waste Management — CIRCODU Thematic Area",
    title: "Waste Management",
    slug: "/our-thematic-areas/waste-management",
    excerpt:
      "Waste is more than an inconvenience; unmanaged, it is a direct threat to public health, biodiversity, and the communities we call home. CIRCODU recognizes that responsible waste management is not optional; it is essential. And we are committed to driving the cultural, behavioral, and systemic shifts needed to make Uganda cleaner, healthier, and more sustainable. ...",
  },
];

const cards = THEMATIC_CARDS.map((item) => ({
  id: item.id,
  variant: "hover",
  front: (
    <div style={{ width: "100%", height: "250px", overflow: "hidden" }}>
      <img
        src={item.img}
        alt={item.alt}
        loading="lazy"
        width="400"
        height="250"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: "5%",
        }}
      />
    </div>
  ),
  back: (
    <div className="cardp">
      <h3 className="cardh text-center" style={{ color: "#008250" }}>
        {item.title}
      </h3>
      <div className="underline-card mx-auto" />
      <p className="cardp">{item.excerpt}</p>
      <div className="text-center">
        <Link
          to={item.slug}
          className="read-more-btn"
          onClick={scrollToTop}
          aria-label={`Read more about ${item.title}`}
        >
          Read More
        </Link>
      </div>
    </div>
  ),
}));

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 8000,
  slidesToShow: 3,
  slidesToScroll: 1,
  cssEase: "ease",
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 2 } },
    { breakpoint: 768, settings: { slidesToShow: 1 } },
  ],
};

function CardOwl() {
  return (
    <div className="card-owl-wrapper mt-4">
      <Slider {...sliderSettings}>
        {cards.map((card) => (
          /*
           * The wrapper div with tabIndex={-1} is the real fix for the
           * aria-hidden/focusable-descendants Lighthouse warning.
           *
           * react-slick clones slides and marks them aria-hidden="true", but
           * any focusable element inside is still reachable by keyboard.
           * Setting tabIndex={-1} on this wrapper removes ALL descendants
           * from the tab order when the slide is a clone — no matter what
           * FlipCard does internally — because browsers honour the nearest
           * ancestor's tabIndex for focus management.
           *
           * inert would be even better but has limited browser support,
           * so tabIndex={-1} is the safest cross-browser approach.
           */
          <div key={card.id} tabIndex={-1} style={{ outline: "none" }}>
            <FlipCard card={card} />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default CardOwl;
